import { drawReeds, drawWater, ell, hills, skyGradient } from '../common';
import type { DrawCtx, SceneArt } from './types';

function lotus(ctx: CanvasRenderingContext2D, x: number, y: number): void {
  ctx.fillStyle = '#F7B7C8';
  for (let i = -2; i <= 2; i++) {
    ctx.save();
    ctx.translate(x + i * 3, y);
    ctx.rotate(i * 0.35);
    ell(ctx, 0, -10, 5, 11);
    ctx.fill();
    ctx.restore();
  }
  ell(ctx, x, y - 3, 6, 3);
  ctx.fillStyle = '#FFE28A';
  ctx.fill();
}

export function smallPads(ctx: CanvasRenderingContext2D, color: string): void {
  for (const [x, y, r] of [[180, 448, 30], [650, 462, 36], [300, 478, 22], [760, 430, 26], [40, 470, 30]]) {
    ctx.beginPath();
    ctx.ellipse(x, y, r, r * 0.22, 0, 0.6, 0.6 + Math.PI * 2 - 0.4);
    ctx.lineTo(x, y);
    ctx.closePath();
    ctx.fillStyle = color;
    ctx.fill();
  }
}

export const pond: SceneArt = {
  id: 'pond',
  rope: '#E4572E',
  ropeBack: '#B8462A',
  handle: '#E4572E',
  ring: 'rgba(255,255,255,0.75)',
  ground: {
    waterTop: '#47A9B0', waterBottom: '#1D6670', shimmer: 'rgba(255,255,255,0.22)',
    padTop: '#4FA552', padEdge: '#245E2A', padVein: 'rgba(30,80,35,0.35)',
    post: '#8A5A3B', postDark: '#6C432A', postCap: '#B98457', ripple: 'rgba(255,255,255,0.55)',
  },
  drawBack(d: DrawCtx) {
    const { ctx, v, t } = d;
    skyGradient(ctx, v, [[0, '#86CFE6'], [0.65, '#CDE9E0'], [1, '#F6E3A4']]);
    const glow = ctx.createRadialGradient(570, 318, 10, 570, 318, 120);
    glow.addColorStop(0, 'rgba(255,230,140,0.9)');
    glow.addColorStop(1, 'rgba(255,230,140,0)');
    ctx.fillStyle = glow;
    ctx.fillRect(450, 198, 240, 240);
    ell(ctx, 570, 318, 38, 38);
    ctx.fillStyle = '#FFE28A';
    ctx.fill();
    ctx.fillStyle = 'rgba(255,255,255,0.85)';
    const span = v.R - v.L + 300;
    for (const [off, y, k] of [[0, 190, 1], [260, 150, 0.8], [520, 215, 0.7]]) {
      const x = v.L - 150 + ((off + (d.reduced ? 0 : t) * 9 * k) % span);
      ell(ctx, x, y, 46 * k, 15 * k);
      ctx.fill();
      ell(ctx, x + 30 * k, y - 10 * k, 30 * k, 16 * k);
      ctx.fill();
      ell(ctx, x - 28 * k, y - 4 * k, 24 * k, 12 * k);
      ctx.fill();
    }
    hills(ctx, v.L, v.R, 352, 34, 0.012, 1.3, '#8DBF7E');
    hills(ctx, v.L, v.R, 362, 20, 0.02, 4.1, '#5E9C5C');
    drawWater(ctx, v, t, this.ground);
    ctx.strokeStyle = 'rgba(255,240,180,0.55)';
    ctx.lineWidth = 2.5;
    for (let i = 0; i < 5; i++) {
      const y = 368 + i * 7;
      const half = 26 - i * 4 + Math.sin(t * 2 + i) * 4;
      ctx.beginPath();
      ctx.moveTo(570 - half, y);
      ctx.lineTo(570 + half, y);
      ctx.stroke();
    }
    smallPads(ctx, '#3F8F46');
    lotus(ctx, 650, 455);
    drawReeds(ctx, 30, 3, t, '#4C7F3A', '#7A4A2A');
    drawReeds(ctx, 762, 4, t, '#4C7F3A', '#7A4A2A');
  },
  drawFront() {},
};
